import { useQuery } from "react-query";

export function useLanguageSelections() {
  return useQuery({
    queryKey: ["languageSelections"],
    queryFn: async () => {
      const data: {
        key: string;
        name: string;
        isDefault: boolean;
      }[] = await fetch(
        "https://cdn.simplelocalize.io/f178fa60730f4f18909cc4c3faf97bb4/_latest/_languages"
      )
        .then((res) => res.json())
        .then((data) => data);
      return data;
    },
  });
}

export function useLanguages(language: string) {
  return useQuery({
    queryKey: ["languages", language],
    queryFn: async () => {
      const projectToken = "f178fa60730f4f18909cc4c3faf97bb4";
      let data;
      await fetch(
        `https://cdn.simplelocalize.io/${projectToken}/_latest/${language}`
      )
        .then((data) => data.json())
        .then((messages) => (data = messages));
      return data;
    },
  });
}
